/**
 * Basil v0.2, P1 — how long the first instruction stays.
 *
 * The brief keeps it "through the writer's first confirmed apply in this episode". A confirmed
 * apply closes the editor, so remembering it inside the component would forget it the moment it
 * mattered; the fact is written to this browser's own storage, keyed by the episode.
 *
 * FAIL-OPEN, and open means SHOWING. Every read and write is wrapped: a private window, cleared
 * site data, a browser that refuses storage, a thumbnail pass that throws on the accessor — all of
 * them answer "no confirmed apply recorded", and the introduction stays. Erring towards more help
 * costs a writer one line of text; erring the other way costs them the only instruction they have.
 *
 * Nothing here is evidence about anything. It is not the audit record, it never reaches the write
 * path, and a writer who clears it simply reads the introduction again.
 */

/** One key per episode: a writer who has learned this in one episode has learned it. */
export function introKey(episodeId: number | string): string {
  return `basil.introduction.done.${String(episodeId)}`;
}

/** True only when this browser recorded a confirmed apply for this episode. */
export function readIntroductionDone(episodeId: number | string): boolean {
  try {
    return window.localStorage.getItem(introKey(episodeId)) === '1';
  } catch {
    return false;
  }
}

/** Record the first confirmed apply. A storage that refuses simply keeps the introduction up. */
export function writeIntroductionDone(episodeId: number | string): void {
  try {
    window.localStorage.setItem(introKey(episodeId), '1');
  } catch {
    // Nothing to do and nothing to say: the introduction stays, which is the safe side.
  }
}
